import { TrendingUp, DollarSign, Clock, Target } from "lucide-react";

const roiData = [
  {
    icon: DollarSign,
    label: "Current Annual Defect Costs",
    value: "$2,400,000",
    detail: "Based on your production volume & defect rate",
    color: "text-crystal-danger",
    bg: "bg-crystal-danger/10",
    border: "border-crystal-danger/20",
  },
  {
    icon: TrendingUp,
    label: "Projected Annual Savings",
    value: "$1,920,000",
    detail: "78% defect prevention × $2.4M baseline",
    color: "text-crystal-success",
    bg: "bg-crystal-success/10",
    border: "border-crystal-success/20",
  },
  {
    icon: Clock,
    label: "Payback Period",
    value: "2.3 months",
    detail: "Full ROI in under one quarter",
    color: "text-crystal-purple",
    bg: "bg-crystal-purple/10",
    border: "border-crystal-purple/20",
  },
  {
    icon: Target,
    label: "5-Year Net Impact",
    value: "$9.1M",
    detail: "Compounding quality improvements",
    color: "text-crystal-blue",
    bg: "bg-crystal-blue/10",
    border: "border-crystal-blue/20",
  },
];

export default function CrystalBallROI() {
  return (
    <section className="relative py-16 px-6">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[hsl(262,80%,60%,0.03)] to-transparent" />

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Return on Investment
          </h2>
          <p className="text-medium-gray max-w-2xl mx-auto">
            Based on your production data, here's the projected financial impact
            of implementing Quality Crystal Ball
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {roiData.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className={`rounded-2xl border ${item.border} ${item.bg} p-6 text-center transition-all duration-300 hover:scale-[1.02]`}
              >
                <Icon className={`w-8 h-8 ${item.color} mx-auto mb-4`} />
                <div className={`text-2xl md:text-3xl font-bold ${item.color} mb-2`}>
                  {item.value}
                </div>
                <p className="text-foreground font-medium text-sm mb-1">{item.label}</p>
                <p className="text-medium-gray text-xs">{item.detail}</p>
              </div>
            );
          })}
        </div>

        {/* ROI Bar Visual */}
        <div className="mt-12 rounded-2xl border border-crystal-purple/15 bg-crystal-card p-6 md:p-8">
          <h3 className="text-lg font-bold text-foreground mb-6 text-center">Cost Comparison</h3>
          <div className="space-y-6 max-w-3xl mx-auto">
            <div>
              <div className="flex justify-between text-sm mb-2">
                <span className="text-medium-gray">Current Defect Costs</span>
                <span className="text-crystal-danger font-semibold">$2,400,000 / year</span>
              </div>
              <div className="h-6 rounded-full bg-muted overflow-hidden">
                <div className="h-full rounded-full bg-gradient-to-r from-crystal-danger/80 to-crystal-danger w-full transition-all duration-1000" />
              </div>
            </div>
            <div>
              <div className="flex justify-between text-sm mb-2">
                <span className="text-medium-gray">With Quality Crystal Ball</span>
                <span className="text-crystal-success font-semibold">$480,000 / year</span>
              </div>
              <div className="h-6 rounded-full bg-muted overflow-hidden">
                <div className="h-full rounded-full bg-gradient-to-r from-crystal-success/80 to-crystal-success w-[20%] transition-all duration-1000" />
              </div>
            </div>
          </div>
          <p className="text-center text-crystal-purple font-bold text-lg mt-6">
            80% reduction in defect-related costs
          </p>
        </div>
      </div>
    </section>
  );
}
